<template>
	<div>
		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<router-link :to="{ name: 'PCReDive'}" tag="li" class="breadcrumb-item">
						<a href="#">首頁</a>
					</router-link>
					<router-link :to="{ name: 'Other'}" tag="li" class="breadcrumb-item">
						<a href="#">其他資訊</a>
					</router-link>
					<li class="breadcrumb-item">
						簡易角色經驗與瑪那計算機
					</li>
				</ol>
			</nav>
			<div class="item-box">
				<h3 class="item-title">
					簡易角色經驗與瑪那計算機
				</h3>
				<div class="form-row align-items-center">
					<div class="col my-1">
						<label class="w-100 text-center" for="a1">
							<img width="60px" class="d-block mx-auto" src="/static/images/item/icon_item_20001.png" alt="60xp">
							60xp
						</label>
						<input type="number" class="form-control" v-model="unitXpConfig.expS" id="a1">
					</div>
					<div class="col my-1">
						<label class="w-100 text-center" for="a2">
							<img width="60px" class="d-block mx-auto" src="/static/images/item/icon_item_20002.png" alt="300xp">
							300xp
						</label>
						<input type="number" class="form-control" v-model="unitXpConfig.expM" id="a2">
					</div>
					<div class="col my-1">
						<label class="w-100 text-center" for="a3">
							<img width="60px" class="d-block mx-auto" src="/static/images/item/icon_item_20003.png" alt="1500xp">
							1500xp
						</label>
						<input type="number" class="form-control" v-model="unitXpConfig.expL" id="a3">
					</div>
					<div class="col my-1">
						<label class="w-100 text-center" for="a4">
							<img width="60px" class="d-block mx-auto" src="/static/images/item/icon_item_20004.png" alt="7500xp">
							7500xp
						</label>
						<input type="number" class="form-control" v-model="unitXpConfig.expXL" id="a4">
					</div>
					<div class="col my-1">
						<label class="w-100 text-center" for="a5">
							<img width="60px" class="d-block mx-auto" src="/static/images/item/icon_item_20005.png" alt="37500xp">
							37500xp
						</label>
						<input type="number" class="form-control" v-model="unitXpConfig.expXXL" id="a5">
					</div>
				</div>
				<div class="form-row align-items-center">
					<div class="col-md-6 col-12 my-1">
						<label for="nowMana">現在瑪那</label>
						<input type="number" class="form-control" id="nowMana" v-model="unitXpConfig.nowMana" placeholder="11111110">
					</div>
					<div class="col-md-6 col-12 my-1">
						<label for="countUnit">角色數量</label>
						<div class="input-group">
							<input type="number" class="form-control" id="countUnit" v-model="unitXpConfig.totalUnit" placeholder="48">
						</div>
					</div>
				</div>
				<div class="form-row align-items-center">
					<div class="col-md-6 col-12 my-1">
						<label for="nowLv">當前等級</label>
						<input type="number" class="form-control" id="nowLv" v-model="unitXpConfig.nowLv" placeholder="118">
					</div>
					<div class="col-md-6 col-12 my-1">
						<label for="targeLv">目標等級</label>
						<div class="input-group">
							<input type="number" class="form-control" id="targeLv" v-model="unitXpConfig.targeLv" placeholder="130">
						</div>
					</div>
				</div>
				<div class="row">					
					<div class="col-12">
						<div class="prod-info-box my-3">
							<div class="row">
								<div class="col-lg-6 col-12 mb-3">
									<div class="prod-data d-flex">
										<span class="title">
											需求經驗
										</span>
										<span class="prod-value">
											{{Number(totalExp).toLocaleString()}}
										</span>
									</div>
								</div>								
								<div class="col-lg-6 col-12 mb-3">
									<div class="prod-data d-flex">
										<span class="title">
											需求瑪那
										</span>
										<span class="prod-value">
											{{Number(totalMana).toLocaleString()}}
										</span>
									</div>
								</div>	
								<div class="col-lg-6 col-12 mb-3">
									<div class="prod-data d-flex">
										<span class="title">
											現有經驗
										</span>
										<span class="prod-value">
											{{Number(totalNowExp).toLocaleString()}}
										</span>
									</div>
								</div>
								<div class="col-lg-6 col-12 mb-3">
									<div class="prod-data d-flex">
										<span class="title">
											現在瑪那
										</span>
										<span class="prod-value">
											{{Number(unitXpConfig.nowMana).toLocaleString()}}
										</span>
									</div>
								</div>
								<br>						
								<div class="col-lg-6 col-12 mb-3" v-if="lackExp < 0 ">
									<div class="prod-data d-flex">
										<span class="title">
											缺少特級藥水
										</span>
										<span class="prod-value">
											{{Math.ceil(Math.abs(lackExp)/7500)}}
											= <img width="15px" alt="mana" title="mana" style="margin-bottom: 3px" src="/static/images/mana.png"> {{(Math.ceil(Math.abs(lackExp)/7500) * 20000).toLocaleString()}}
										</span>
									</div>
								</div>
								<div class="col-lg-6 col-12 mb-3">
									<div class="prod-data d-flex">
										<span class="title">
											<span v-if="lackMana > 0 ">尚餘瑪那</span>
											<div v-else>缺少瑪那</div> 
										</span>
										<span class="prod-value">
											{{Number(lackMana).toLocaleString()}}
										</span>
									</div>
								</div>	
								<div class="col-12 text-right">
									<button type="button" class="pcbtn primary" @click="saveConfig()">
										儲存設定
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="item-box mt-3">
				<h3 class="item-title">
					簡易技能需求瑪那計算機
				</h3>
				<div class="form-row align-items-center">
					<div class="col-md-6 col-12 my-1">
						<label for="nowManaOnly">現在瑪那</label>
						<input type="number" class="form-control" id="nowManaOnly" v-model="unitManaConfig.nowMana" placeholder="11111110">
					</div>
					<div class="col-md-6 col-12 my-1">
						<label for="countUnitOnly">角色數量</label>
						<div class="input-group">
							<input type="number" class="form-control" id="countUnitOnly" v-model="unitManaConfig.totalUnit" placeholder="48">
						</div>
					</div>
				</div>
				<div class="form-row align-items-center">
					<div class="col-md-6 col-12 my-1">
						<label for="nowLvOnly">當前等級</label>
						<input type="number" class="form-control" id="nowLvOnly" v-model="unitManaConfig.nowLv" placeholder="118">
					</div>
					<div class="col-md-6 col-12 my-1">
						<label for="targeLvOnly">目標等級</label>
						<div class="input-group">
							<input type="number" class="form-control" id="targeLvOnly" v-model="unitManaConfig.targeLv" placeholder="130">
						</div>
					</div>
				</div>
				<div class="row">					
					<div class="col-12">
						<div class="prod-info-box my-3">
							<div class="row">	
								<div class="col-lg-6 col-12 mb-3">
									<div class="prod-data d-flex">
										<span class="title">
											需求瑪那
										</span>
										<span class="prod-value">
											{{Number(totalManaOnly).toLocaleString()}}
										</span>
									</div>
								</div>
								<div class="col-lg-6 col-12 mb-3">
									<div class="prod-data d-flex">
										<span class="title">
											<span v-if="lackManaOnly > 0 ">尚餘瑪那</span>
											<div v-else>缺少瑪那</div> 
										</span>
										<span class="prod-value">
											{{Number(lackManaOnly).toLocaleString()}}
										</span>
									</div>
								</div>	
								<div class="col-12 text-right">
									<button type="button" class="pcbtn primary" @click="saveManaConfig()">
										儲存設定
									</button>
								</div>	
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import experience_unit from '../../assets/edata/experience_unit.txt'
import skill_cost from '../../assets/edata/skill_cost.txt'
export default {
	name: 'UnitXp',
	metaInfo: {
		// if no subcomponents specify a metaInfo.title, this title will be used
		title: '簡易角色經驗與瑪那計算機',
		// all titles will be injected into this template
		titleTemplate: '%s | 蘭德索爾圖書館 公主連結 Wiki',
		meta: [
			{ name: 'description', content: "超異域公主連結☆Re:Dive 的女神的經驗所需表" }
		]
	},
	data() {
		return {
			exp: {},
			mana: {},
			unitXpConfig: {
				"expS": "1000",
				"expM": "1000",
				"expL": "1000",
				"expXL": "1000",
				"expXXL": "500",				
				"nowLv": "139",
				"targeLv": "142",
				"totalUnit": "50",
				"nowMana": "123456789",	
			},
			unitManaConfig: {
				"nowLv": "139",
				"targeLv": "142",
				"totalUnit": "50",
				"nowMana": "0",	
			}			
		}
	},
	created: function() {
		var self = this;		
		var experienceUnit = JSON.parse(self.atou(experience_unit));
		var exp = experienceUnit;
		var getNowExp = _.forEach(exp, function(o, i) {
			if (i == 0) {
				o["now_exp"] = 0;
				return;
			}
			var nowExp = Number(o.total_exp) - Number(exp[Number(i) - 1]["total_exp"]);
			o["now_exp"] = nowExp;
		});
		self.exp = getNowExp;

		var skillCost = JSON.parse(self.atou(skill_cost));
		var mana = skillCost;
		var mymana = 0
		var getNowmana = _.forEach(mana, function(o, i) {
			if (i == 0) {
				o["total_mana"] = 0;
				return;
			}			
			o["total_mana"] = Number(o.cost)*4;
		});
		self.mana = getNowmana;
	},
	computed: {
		totalExp: function() {
			var self = this;
			var rankTop = self.exp.length -1;
			if (Number(self.unitXpConfig.nowLv) > rankTop || Number(self.unitXpConfig.targeLv) > rankTop) {
				return 0;
			}
			if (Number(self.unitXpConfig.nowLv) > Number(self.unitXpConfig.targeLv)) {
				return 0;
			}
			var targetObj = _.find(self.exp, ["unit_level", self.unitXpConfig.targeLv]);
			var nowObj = _.find(self.exp, ["unit_level", self.unitXpConfig.nowLv]);			
			return (Number(targetObj.total_exp) - Number(nowObj.total_exp)) * Number(self.unitXpConfig.totalUnit);
		},
		totalNowExp: function() {
			var self = this;	
			return (Number(self.unitXpConfig.expS)*60)+(Number(self.unitXpConfig.expM)*300)+(Number(self.unitXpConfig.expL)*1500)+(Number(self.unitXpConfig.expXL)*7500)+(Number(self.unitXpConfig.expXL)*37500);
		},
		lackExp: function() {
			return this.totalNowExp - this.totalExp;
		},
		totalMana: function() {
			var self = this;
			var rankTop = self.exp.length  -1;
			if (Number(self.unitXpConfig.nowLv) > rankTop || Number(self.unitXpConfig.targeLv) > rankTop) {
				return 0;
			}
			if (Number(self.unitXpConfig.nowLv) > Number(self.unitXpConfig.targeLv)) {
				return 0;
			}
			var myMana = _.filter(self.mana,function(o){
				return Number(o.target_level) > Number(self.unitXpConfig.nowLv) && Number(o.target_level) <= Number(self.unitXpConfig.targeLv)
			})
			var totalMana = 0;
			_.forEach(myMana,function(o){
				totalMana += o.total_mana
			});
			return Number(totalMana) * Number(self.unitXpConfig.totalUnit);
		},
		lackMana: function() {
			var expToMana = 0;
			var nowMana = Number(this.unitXpConfig.nowMana);
			var lackExp = this.lackExp;
			if (lackExp < 0 ) {
				expToMana = Math.ceil(Math.abs(lackExp)/7500) * 20000;
			}
			return (nowMana - this.totalMana) - expToMana;
		},
		totalManaOnly: function() {
			var self = this;
			var rankTop = self.exp.length  -1;
			if (Number(self.unitManaConfig.nowLv) > rankTop || Number(self.unitManaConfig.targeLv) > rankTop) {
				return 0;
			}
			if (Number(self.unitManaConfig.nowLv) > Number(self.unitManaConfig.targeLv)) {
				return 0;
			}
			var myMana = _.filter(self.mana,function(o){
				return Number(o.target_level) > Number(self.unitManaConfig.nowLv) && Number(o.target_level) <= Number(self.unitManaConfig.targeLv)
			})
			var totalMana = 0;
			_.forEach(myMana,function(o){
				totalMana += o.total_mana
			});
			return Number(totalMana) * Number(self.unitManaConfig.totalUnit);
		},
		lackManaOnly: function() {
			var expToMana = 0;
			var nowMana = Number(this.unitManaConfig.nowMana);
			return (nowMana - this.totalManaOnly);
		}
	},
	methods: {
		loadConfig: function() {
			var config = JSON.parse(localStorage.getItem("unitXpConfig"));			
			this.unitXpConfig.expS = config.expS;
			this.unitXpConfig.expM = config.expM;
			this.unitXpConfig.expL = config.expL;
			this.unitXpConfig.expXL = config.expXL;
			this.unitXpConfig.expXXL = config.expXXL;
			this.unitXpConfig.nowLv = config.nowLv;
			this.unitXpConfig.targeLv = config.targeLv;
			this.unitXpConfig.totalUnit = config.totalUnit;
			this.unitXpConfig.nowMana = config.nowMana;
		},
		saveConfig: function() {
			var self = this;
			var unitXpConfig = JSON.stringify(self.unitXpConfig);
			if (typeof(Storage) !== "undefined") {
				localStorage.setItem("unitXpConfig", unitXpConfig);
			}			
		},
		saveManaConfig: function() {
			var self = this;
			var unitManaConfig = JSON.stringify(self.unitManaConfig);
			if (typeof(Storage) !== "undefined") {
				localStorage.setItem("unitManaConfig", unitManaConfig);
			}			
		},
		loadManaConfig: function() {
			var config = JSON.parse(localStorage.getItem("unitManaConfig"));
			this.unitManaConfig.nowLv = config.nowLv;
			this.unitManaConfig.targeLv = config.targeLv;
			this.unitManaConfig.totalUnit = config.totalUnit;
			this.unitManaConfig.nowMana = config.nowMana;
		}
	},
	mounted: function() {
		var self = this;
		if (localStorage.getItem("unitXpConfig") != null){
			self.loadConfig();
		}

		if (localStorage.getItem("unitManaConfig") != null){
			self.loadManaConfig();
		}
	}
}

</script>
<style scoped>
.pcbtn.primary:active{	
	background: linear-gradient(to bottom, #ff5079 0%, #b74152 100%);
}
</style>
